import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Candidate, DefaultCandidate, candidateValidationSchema } from '@/Models/Candidate';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import CandidateInputForm from './CandidateInputForm';
import CandidateInputFormHeader from './CandidateInputFormHeader';
import CheckboxWithTooltip from './CheckboxWithTooltip';

const CandidateAddSection = (): React.JSX.Element => {
    const { createCandidateAccountAsync } = useInviteCandidateContext();
    const form = useForm({
        resolver: yupResolver(candidateValidationSchema),
        mode: 'onSubmit',
        defaultValues: DefaultCandidate,
    });

    const validateApplicantAddition = async (values: Candidate): Promise<boolean> => {
        let createCandidateAccountResponse = '';

        createCandidateAccountResponse = await createCandidateAccountAsync({ ...(values as Candidate) });

        if (createCandidateAccountResponse) {
            form.setError('email', { type: 'custom', message: createCandidateAccountResponse });
            return false;
        }

        return true;
    };

    const addCandidateHandlerAsync = async (values: Candidate) => {
        if (await validateApplicantAddition(values)) {
            form.reset();
        }
    };

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(addCandidateHandlerAsync)}>
                <div className="my-2.5 flex flex-col gap-2.5">
                    <CandidateInputFormHeader />
                    <div>
                        <CandidateInputForm />
                        <CheckboxWithTooltip />
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};

export default CandidateAddSection;
